import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import {
  STEP_MODAL_TYPES,
  TourStepBase,
} from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { BalancesStepUi } from "@src/widgets/onboarding/ui/tours/MandatoryInitialSetup/steps/BalancesStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class BalancesStep extends TourStepBase {
  component = BalancesStepUi
  name = `${ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP}_Balances`

  constructor() {
    super({
      highlightElements: [
        ".ant-table-row[data-row-key='0']",
        ".balances_totalBlock__ZWG50",
      ],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.balances,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Primary section for managing all your assets",
      title: "Balances",
    }
  }
}
